// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Mensalistas.css */
:root {
  --bg: #0b0d12;
  --card: #11141b;
  --card-2: #0f1218;
  --text: #e7edf6;
  --muted: #a6b0c3;
  --border: #1c2330;
  --brand: #22c55e;
  --brand-2: #16a34a;
  --danger: #ef4444;
  --info: #3b82f6;

  --radius: 16px;
  --radius-sm: 12px;
  --shadow: 0 8px 24px rgba(0,0,0,0.35);
  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);

  --gap: 16px;
  --gap-lg: 24px;
}

* { box-sizing: border-box; }
.muted { color: var(--muted); }

/* Container geral */
.mensalistas { display: grid; gap: var(--gap-lg); }

/* Título + Busca */
.mensalistas-head { display: grid; gap: 12px; }
.head-title h3 {
  margin: 0; font-size: 18px; font-weight: 800; letter-spacing: .2px;
}
.head-title .muted { font-size: 13px; }

/* Busca */
.search { position: relative; display: grid; align-items: center; }
.search-input {
  width: 100%;
  padding: 12px 40px;
  background: #0c0f14;
  border: 1px solid var(--border);
  border-radius: 14px;
  color: var(--text);
  outline: none;
}
.search-input::placeholder { color: #94a3b8; }
.search-input:focus { border-color: #263145; }
.search-icon {
  position: absolute; left: 12px; font-size: 16px; opacity: .8;
}
.search-clear {
  position: absolute; right: 6px; top: 50%; transform: translateY(-50%);
  border: 0; background: transparent; color: var(--muted);
  font-size: 18px; width: 32px; height: 32px; border-radius: 999px; cursor: pointer;
}
.search-clear:hover { color: var(--text); }

/* Grid das duas listas */
.mensalistas-grid {
  display: grid; grid-template-columns: 1fr; gap: var(--gap-lg); min-width: 0;
}
@media (min-width: 980px) { .mensalistas-grid { grid-template-columns: 1fr 1fr; } }

/* Card de coluna */
.card {
  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 14px;
  box-shadow: var(--shadow);
  min-width: 0;
}
.card-elev {
  background:
    radial-gradient(900px 320px at 110% -20%, rgba(34,197,94,.08), transparent),
    radial-gradient(700px 260px at -10% 115%, rgba(59,130,246,.06), transparent),
    linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);
}
.card-head {
  display: flex; align-items: center; justify-content: space-between;
  gap: 8px; margin-bottom: 10px;
}
.card-head h4 { margin: 0; font-size: 16px; font-weight: 800; }
.badge-count {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 28px; height: 22px; padding: 0 8px; border-radius: 999px;
  background: rgba(59,130,246,0.12); color: #93c5fd; border: 1px solid rgba(59,130,246,0.25);
  font-size: 12px; font-weight: 800;
}

/* Lista de pessoas */
.list { list-style: none; margin: 0; padding: 0; display: grid; gap: 12px; }

/* Novo card de pessoa (mais elegante) */
.person-card {
  border: 1px solid var(--border);
  border-radius: 14px;
  background:
    linear-gradient(180deg, #0c0f14 0%, #0d1016 100%);
  padding: 12px;
  display: grid;
  gap: 10px;
  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
}
.person-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-soft);
  border-color: #243043;
}

/* Linha superior: avatar + info */
.person-row-top {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  align-items: center;
  min-width: 0;
}
.avatar {
  width: 36px; height: 36px;
  border-radius: 10px;
  display: grid; place-items: center;
  background: rgba(34,197,94,0.12);
  border: 1px solid rgba(34,197,94,0.22);
  color: #86efac; font-weight: 800;
}
.person-info { min-width: 0; display: grid; gap: 3px; }
.person-name {
  font-weight: 800; line-height: 1.25;
  overflow: hidden; text-overflow: ellipsis;
  display: -webkit-box; 
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical; /* 2 linhas */
  line-clamp: 2;
}
.person-sub {
  color: var(--muted); font-size: 12px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

/* Ações (linha de baixo): botão ghost, discreto */
.person-row-actions {
  display: flex; justify-content: flex-end;
  border-top: 1px solid #121826;
  padding-top: 10px;
}

/* Botões linha (discretos e menores) */
.btn-line {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text);
  padding: 4px 8px;         /* <<< menor altura/largura */
  border-radius: 8px;       /* canto mais suave */
  font-weight: 600;
  font-size: 12px;          /* <<< reduzido */
  line-height: 1.2;
  cursor: pointer;
  transition: all .2s ease;
  white-space: nowrap;
}

.btn-line:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-soft);
}

/* Variantes */
.btn--primary-line {
  border-color: rgba(34,197,94,0.25);
  color: #86efac;
  background: rgba(34,197,94,0.08);
}
.btn--primary-line:hover {
  border-color: rgba(34,197,94,0.4);
  background: rgba(34,197,94,0.15);
}

.btn--danger-line {
  border-color: rgba(239,68,68,0.25);
  color: #fca5a5;
  background: rgba(239,68,68,0.08);
}
.btn--danger-line:hover {
  border-color: rgba(239,68,68,0.4);
  background: rgba(239,68,68,0.15);
}
/* Empty */
.empty {
  border: 1px dashed var(--border);
  border-radius: 12px;
  padding: 18px;
  background: #0c0f14;
  text-align: center;
  color: var(--muted);
}
.empty-emoji { font-size: 26px; margin-bottom: 6px; }
.empty-title { font-weight: 800; color: var(--text); margin-bottom: 2px; }
.empty-sub { font-size: 13px; }

/* Erros */
.error-message {
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fecaca;
  padding: 12px 14px;
  border-radius: 12px;
  margin-top: 12px;
}

/* Mobile refinements */
@media (max-width: 380px) {
  .search-input { padding-left: 36px; padding-right: 36px; }
  .person-row-actions { justify-content: stretch; }
  .btn-line { width: 100%; text-align: center; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Mensalistas.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;;EAEf,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;;EAE1C,WAAW;EACX,cAAc;AAChB;;AAEA,IAAI,sBAAsB,EAAE;AAC5B,SAAS,mBAAmB,EAAE;;AAE9B,oBAAoB;AACpB,eAAe,aAAa,EAAE,kBAAkB,EAAE;;AAElD,mBAAmB;AACnB,oBAAoB,aAAa,EAAE,SAAS,EAAE;AAC9C;EACE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB;AACpE;AACA,qBAAqB,eAAe,EAAE;;AAEtC,UAAU;AACV,UAAU,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAClE;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;AACA,6BAA6B,cAAc,EAAE;AAC7C,sBAAsB,qBAAqB,EAAE;AAC7C;EACE,kBAAkB,EAAE,UAAU,EAAE,eAAe,EAAE,WAAW;AAC9D;AACA;EACE,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE,2BAA2B;EACrE,SAAS,EAAE,uBAAuB,EAAE,mBAAmB;EACvD,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,eAAe;AACnF;AACA,sBAAsB,kBAAkB,EAAE;;AAE1C,yBAAyB;AACzB;EACE,aAAa,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,YAAY;AAC7E;AACA,4BAA4B,oBAAoB,8BAA8B,EAAE,EAAE;;AAElF,mBAAmB;AACnB;EACE,uEAAuE;EACvE,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE;;;+DAG6D;AAC/D;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,QAAQ,EAAE,mBAAmB;AAC/B;AACA,gBAAgB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC9D;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE,oBAAoB;EACnE,iCAAiC,EAAE,cAAc,EAAE,uCAAuC;EAC1F,eAAe,EAAE,gBAAgB;AACnC;;AAEA,qBAAqB;AACrB,QAAQ,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,SAAS,EAAE;;AAE3E,wCAAwC;AACxC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB;qDACmD;EACnD,aAAa;EACb,aAAa;EACb,SAAS;EACT,6EAA6E;AAC/E;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,aAAa,EAAE,mBAAmB;EAClC,gCAAgC;EAChC,sCAAsC;EACtC,cAAc,EAAE,gBAAgB;AAClC;AACA,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE;AACtD;EACE,gBAAgB,EAAE,iBAAiB;EACnC,gBAAgB,EAAE,uBAAuB;EACzC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B,EAAE,aAAa;EAC3C,aAAa;AACf;AACA;EACE,mBAAmB,EAAE,eAAe;EACpC,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;;AAEA,kDAAkD;AAClD;EACE,aAAa,EAAE,yBAAyB;EACxC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB,UAAU,6BAA6B;EACvD,kBAAkB,QAAQ,qBAAqB;EAC/C,gBAAgB;EAChB,eAAe,WAAW,iBAAiB;EAC3C,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,kCAAkC;EAClC,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;AACA,UAAU;AACV;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,eAAe,eAAe,EAAE,kBAAkB,EAAE;AACpD,eAAe,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACzE,aAAa,eAAe,EAAE;;AAE9B,UAAU;AACV;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB,kBAAkB,EAAE,mBAAmB,EAAE;EACzD,sBAAsB,wBAAwB,EAAE;EAChD,YAAY,WAAW,EAAE,kBAAkB,EAAE;AAC/C","sourcesContent":["/* src/components/Mensalistas.css */\n:root {\n  --bg: #0b0d12;\n  --card: #11141b;\n  --card-2: #0f1218;\n  --text: #e7edf6;\n  --muted: #a6b0c3;\n  --border: #1c2330;\n  --brand: #22c55e;\n  --brand-2: #16a34a;\n  --danger: #ef4444;\n  --info: #3b82f6;\n\n  --radius: 16px;\n  --radius-sm: 12px;\n  --shadow: 0 8px 24px rgba(0,0,0,0.35);\n  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);\n\n  --gap: 16px;\n  --gap-lg: 24px;\n}\n\n* { box-sizing: border-box; }\n.muted { color: var(--muted); }\n\n/* Container geral */\n.mensalistas { display: grid; gap: var(--gap-lg); }\n\n/* Título + Busca */\n.mensalistas-head { display: grid; gap: 12px; }\n.head-title h3 {\n  margin: 0; font-size: 18px; font-weight: 800; letter-spacing: .2px;\n}\n.head-title .muted { font-size: 13px; }\n\n/* Busca */\n.search { position: relative; display: grid; align-items: center; }\n.search-input {\n  width: 100%;\n  padding: 12px 40px;\n  background: #0c0f14;\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  color: var(--text);\n  outline: none;\n}\n.search-input::placeholder { color: #94a3b8; }\n.search-input:focus { border-color: #263145; }\n.search-icon {\n  position: absolute; left: 12px; font-size: 16px; opacity: .8;\n}\n.search-clear {\n  position: absolute; right: 6px; top: 50%; transform: translateY(-50%);\n  border: 0; background: transparent; color: var(--muted);\n  font-size: 18px; width: 32px; height: 32px; border-radius: 999px; cursor: pointer;\n}\n.search-clear:hover { color: var(--text); }\n\n/* Grid das duas listas */\n.mensalistas-grid {\n  display: grid; grid-template-columns: 1fr; gap: var(--gap-lg); min-width: 0;\n}\n@media (min-width: 980px) { .mensalistas-grid { grid-template-columns: 1fr 1fr; } }\n\n/* Card de coluna */\n.card {\n  background: linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 14px;\n  box-shadow: var(--shadow);\n  min-width: 0;\n}\n.card-elev {\n  background:\n    radial-gradient(900px 320px at 110% -20%, rgba(34,197,94,.08), transparent),\n    radial-gradient(700px 260px at -10% 115%, rgba(59,130,246,.06), transparent),\n    linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);\n}\n.card-head {\n  display: flex; align-items: center; justify-content: space-between;\n  gap: 8px; margin-bottom: 10px;\n}\n.card-head h4 { margin: 0; font-size: 16px; font-weight: 800; }\n.badge-count {\n  display: inline-flex; align-items: center; justify-content: center;\n  min-width: 28px; height: 22px; padding: 0 8px; border-radius: 999px;\n  background: rgba(59,130,246,0.12); color: #93c5fd; border: 1px solid rgba(59,130,246,0.25);\n  font-size: 12px; font-weight: 800;\n}\n\n/* Lista de pessoas */\n.list { list-style: none; margin: 0; padding: 0; display: grid; gap: 12px; }\n\n/* Novo card de pessoa (mais elegante) */\n.person-card {\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  background:\n    linear-gradient(180deg, #0c0f14 0%, #0d1016 100%);\n  padding: 12px;\n  display: grid;\n  gap: 10px;\n  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;\n}\n.person-card:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-soft);\n  border-color: #243043;\n}\n\n/* Linha superior: avatar + info */\n.person-row-top {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 10px;\n  align-items: center;\n  min-width: 0;\n}\n.avatar {\n  width: 36px; height: 36px;\n  border-radius: 10px;\n  display: grid; place-items: center;\n  background: rgba(34,197,94,0.12);\n  border: 1px solid rgba(34,197,94,0.22);\n  color: #86efac; font-weight: 800;\n}\n.person-info { min-width: 0; display: grid; gap: 3px; }\n.person-name {\n  font-weight: 800; line-height: 1.25;\n  overflow: hidden; text-overflow: ellipsis;\n  display: -webkit-box; \n  -webkit-line-clamp: 2; \n  -webkit-box-orient: vertical; /* 2 linhas */\n  line-clamp: 2;\n}\n.person-sub {\n  color: var(--muted); font-size: 12px;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n\n/* Ações (linha de baixo): botão ghost, discreto */\n.person-row-actions {\n  display: flex; justify-content: flex-end;\n  border-top: 1px solid #121826;\n  padding-top: 10px;\n}\n\n/* Botões linha (discretos e menores) */\n.btn-line {\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--text);\n  padding: 4px 8px;         /* <<< menor altura/largura */\n  border-radius: 8px;       /* canto mais suave */\n  font-weight: 600;\n  font-size: 12px;          /* <<< reduzido */\n  line-height: 1.2;\n  cursor: pointer;\n  transition: all .2s ease;\n  white-space: nowrap;\n}\n\n.btn-line:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-soft);\n}\n\n/* Variantes */\n.btn--primary-line {\n  border-color: rgba(34,197,94,0.25);\n  color: #86efac;\n  background: rgba(34,197,94,0.08);\n}\n.btn--primary-line:hover {\n  border-color: rgba(34,197,94,0.4);\n  background: rgba(34,197,94,0.15);\n}\n\n.btn--danger-line {\n  border-color: rgba(239,68,68,0.25);\n  color: #fca5a5;\n  background: rgba(239,68,68,0.08);\n}\n.btn--danger-line:hover {\n  border-color: rgba(239,68,68,0.4);\n  background: rgba(239,68,68,0.15);\n}\n/* Empty */\n.empty {\n  border: 1px dashed var(--border);\n  border-radius: 12px;\n  padding: 18px;\n  background: #0c0f14;\n  text-align: center;\n  color: var(--muted);\n}\n.empty-emoji { font-size: 26px; margin-bottom: 6px; }\n.empty-title { font-weight: 800; color: var(--text); margin-bottom: 2px; }\n.empty-sub { font-size: 13px; }\n\n/* Erros */\n.error-message {\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #fecaca;\n  padding: 12px 14px;\n  border-radius: 12px;\n  margin-top: 12px;\n}\n\n/* Mobile refinements */\n@media (max-width: 380px) {\n  .search-input { padding-left: 36px; padding-right: 36px; }\n  .person-row-actions { justify-content: stretch; }\n  .btn-line { width: 100%; text-align: center; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
